<template>
  <div class="rankData">
    <div class="title-con">
      <span class="title">喜马拉雅用户数据：</span>
      <el-select v-model="curCityId" placeholder="请选择城市" v-loading="initLoading" @change="initFetch">
        <el-option
          v-for="item in cityList"
          :key="item.cityId"
          :label="item.cityName"
          :value="item.cityId">
        </el-option>
      </el-select>
    </div>
    <div class="rank-board" v-if="cityList.length">
      <el-row type="flex" class="row-bg board-head" justify="space-between" align="middle">
        <el-radio-group v-model="rankType" fill="#f86442" @change="switchType">
          <el-radio-button label="album">整张专辑销售排行榜</el-radio-button>
          <el-radio-button label="track">单条声音销售排行榜</el-radio-button>
        </el-radio-group>
        <div class="goSearch">
          <div class="searchInput">
            <el-input :placeholder="`请输入${rankType === 'album' ? '专辑' : '声音'}名称`" v-model="searchKey"></el-input>
            <i class="el-input__icon el-icon-close" @click="initFetch" v-show="searchKey.length"></i>
          </div>
          <el-button type="primary" @click="getRankList">搜索</el-button>
          <!-- <el-button type="primary">导出表格</el-button> -->
        </div>
      </el-row>
      <el-tabs v-model="curClassIdx" :value="curClassName" v-loading="initLoading" @tab-click="switchTab(curClassIdx)">
        <el-tab-pane :label="item" v-for="item in classify" :key="item"></el-tab-pane>
      </el-tabs>
      <el-row type="flex" class="row-bg classify-board" justify="end" align="middle">
        <div class="sortBy">
          <span>排序方式: </span>
          <el-select v-model="curSortType" placeholder="请选择" @change="getRankList">
            <el-option
              v-for="item in sortTypes"
              :key="item.key"
              :label="item.name"
              :value="item.key">
            </el-option>
          </el-select>
        </div>
        <el-radio-group v-if="rankType=='album'" v-model="rankTime" size="small" fill="#f86442" @change="getRankList">
          <el-radio-button label="1">昨日</el-radio-button>
          <el-radio-button label="2">最近一周</el-radio-button>
        </el-radio-group>
        <el-button type="primary" size="small" style="pointer-events: none;" v-else>昨日</el-button>
      </el-row>

      <el-table :data="tableData" ref="table" stripe :empty-text="ret === 0 ? '该分类下暂无排行数据' : dataMsg" style="width: 100%" v-loading="rankLoading">
        <el-table-column prop="albumId" label="专辑id" width="120"></el-table-column>
        <el-table-column label="专辑封面" width="168">
          <template slot-scope="scope">
            <div class="img-placeholder">
              <div class="img-box">
                <img class="albumCover" :src="scope.row.coverPath">
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="albumName" label="专辑名称" width="216"></el-table-column>
        <el-table-column label="分类" width="168">
          <template slot-scope="scope">
            <p>{{ scope.row.categoryName }}</p>
            <p class="cateName" v-if="onSearching">【子站分类: {{ scope.row.subsiteCategoryName }}】</p>
          </template>
        </el-table-column>
        <el-table-column prop="ranking" label="排行" width="168"></el-table-column>
      </el-table>

    </div>
  </div>
</template>

<script>
  import { getRankCity, getRankClassify, getRanking, searchRanking } from '../../api'
  export default {
    data() {
      return {
        cityList: [],
        classify: [],
        tableData: [],
        sortTypes: [
          {
            key: '1',
            name: '按销量'
          },
          {
            key: '2',
            name: '按销售额'
          },
          {
            key: '3',
            name: '按收听时长'
          }
        ],
        initLoading: false,
        curCityId: '',
        rankType: 'album',
        curClassIdx: '0',
        curClassName: '全部',
        searchKey: '',
        searchTabIdx: '',
        curSortType: '1',
        rankTime: '1',
        rankLoading: false,
        ret: '',
        dataMsg: ''
      }
    },
    computed: {
      onSearching() {
        let _this = this;
        let isExist = _this.classify.some(item => { return item === '搜索结果' })
        return isExist
      }
    },
    methods: {
      goSearch() {
        let _this = this;
        _this.addSearchTab();
        searchRanking({
          name: _this.searchKey,
          city: _this.curCityId,
          type: _this.curSortType,
          time: _this.rankTime
        }).then(res => {
          _this.rankLoading = false;
          if(res.ret === 0){
            _this.tableData = res.data;
          }else{
            console.log('列表搜索请求失败')
          }
        })
      },
      goRanking() {
        let _this = this;
        getRanking({
          city: _this.curCityId,
          category: _this.classify[_this.curClassIdx],
          type: _this.curSortType,
          time: _this.rankTime
        }).then(res => {
          _this.rankLoading = false;
          _this.ret = res.ret;
          if(res.ret === 0){
            _this.tableData = res.data;
          }else{
            _this.dataMsg = res.msg;
          }
        })
      },
      addSearchTab() {
        let _this = this;
        if(!_this.onSearching){
          _this.classify.push('搜索结果');
          _this.searchTabIdx = _this.classify.length - 1;
          _this.curClassIdx = _this.searchTabIdx.toString();
        }
      },
      delSearchTab(idx) {
        let _this = this;
        if(_this.onSearching){
          _this.searchKey = '';
          _this.classify.pop();
          _this.curClassIdx = idx || '0';
        }
      },
      switchType(type) {
        let _this = this;
        _this.rankTime = type === 'track' ? '3' : '1';
        _this.initFetch()
      },
      initFetch() {
        let _this = this;
        _this.delSearchTab();
        _this.getRankList();
      },
      switchTab(idx) {
        let _this = this;
        if(idx != _this.classify.length - 1 || _this.classify[idx] !== '搜索结果'){
          _this.delSearchTab(idx);
          // reset && fetch
          _this.rankLoading = true;
          _this.tableData = [];
          _this.goRanking();
        }
      },
      getRankList() {
        let _this = this;
        // reset && fetch
        _this.rankLoading = true;
        _this.tableData = [];
        _this.searchKey ? _this.goSearch() : _this.goRanking();
      }
    },
    created() {
      let _this = this;
      _this.initLoading = true;
      Promise.all([
        getRankCity(),
        getRankClassify()
      ]).then(res => {
        _this.initLoading = false;
        if(res[0].ret === 0){
          _this.cityList = res[0].data;
          _this.curCityId = _this.cityList[0].cityId;
          if(res[1].ret === 0){
            _this.classify = res[1].data;
            _this.goRanking()
          }else{
            console.log('分类列表请求失败')
          }
        }else{
          console.log('城市列表请求失败')
        }
      })
    }
  }
</script>

<style lang="scss" scoped>
.rankData{
  width: 840px;
}
.title-con{
  display: flex;
  align-items: center;
  padding: 10px 20px;
  margin-bottom: 10px;
  font-size: 18px;
  background-color: #fff;
}
.board-head{
  padding: 10px 20px;
  background-color: #fff;
  .goSearch{
    display: flex;
    .searchInput{
      position: relative;
    }
  }
}
.classify-board{
  margin: 5px 0;
  padding: 10px 20px;
  background-color: #fff;
  .sortBy{
    margin-right: 10px;
    span{
      margin-right: 10px;
    }
  }
}
.rank-board{
  margin-bottom: 56px;
  .cateName{
    font-size: 12px;
    color: #999;
  }
}
.img-placeholder{
  width: 100px;
  padding: 10px;
  .img-box{
    position: relative;
    height: 0;
    padding-bottom: 100%;
    img{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// albumsRank.vue?7007221b